import React from 'react';

const MobileMerchantList = ({ children }) => {
  const length = children.length;

  if (length <= 2)
    return (
      <div className='mobile-merchant-list pt-2'>
        <div>
          {React.Children.map(children, (child) => (
            <div className='merchant-card-wrapper'>{child}</div>
          ))}
        </div>
      </div>
    );
  else
    return (
      <div className='mobile-merchant-list'>
        <div className='merchant-card-parent'>
          {React.Children.map(children, (child) => (
            <div className='merchant-card-wrapper'>{child}</div>
          ))}
        </div>
      </div>
    );
};

export default MobileMerchantList;
